module.exports = __webpack_public_path__ + "img/background.92a096b1.png";